import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  adGroups: [],
  campaignDailyBudgetLimit: null,
  dailyBudgetAmount: 100000,
  previewDailyBudgetAmount: 100000,
}

export const showAdGroupDailyBudgetEdit = createAxiosThunk(
  'dashboard/showAdGroupDailyBudgetEdit',
  async adGroupIds => {
    const adGroupsResponse = await api.ad.getAdGroups(adGroupIds)
    const adGroupDtos = adGroupsResponse.data?.adGroupDtos ?? []
    const campaignIds = [
      ...new Set(adGroupDtos.map(({ campaignId }) => campaignId)),
    ].filter(id => id !== null && id !== undefined)
    if (campaignIds.length === 0) {
      return { data: { adGroupDtos, campaigns: [] } }
    }
    const campaignsResponse = await api.ad.getCampaignsById(campaignIds)
    return {
      data: {
        adGroupDtos,
        campaigns: campaignsResponse.data?.campaigns ?? [],
      },
    }
  }
)

export const updateAdGroupsDailyBudget = createAxiosThunk(
  'dashboard/updateAdGroupsDailyBudget',
  (noArgs, { getState }) => {
    const { adGroups, previewDailyBudgetAmount } =
      getState().dashboard.operation.adGroupDailyBudgetEdit
    return api.ad.patchAdGroupsDailyBudget({
      adGroupIds: adGroups.map(({ id }) => id),
      dailyBudgetAmount: previewDailyBudgetAmount,
    })
  }
)
const adGroupDailyBudgetEditSlice = createSlice({
  name: 'dashboard/adGroupDailyBudgetEdit',
  initialState,

  reducers: {
    hideAdGroupDailyBudgetEdit: () => initialState,
    showPreview: (state, { payload }) => {
      state.previewDailyBudgetAmount = payload
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(showAdGroupDailyBudgetEdit.pending, state => {
      state.isLoading = true
      state.visible = true
    })

    builder.addCase(
      showAdGroupDailyBudgetEdit.rejected,
      (state, { payload }) => {
        state.loadingError = payload
        state.isLoading = false
      }
    )

    builder.addCase(
      showAdGroupDailyBudgetEdit.fulfilled,
      (state, { payload: { adGroupDtos, campaigns } }) => {
        const adGroups = adGroupDtos.map(
          ({ id, name, campaignId, dailyBudget: { amount } }) => ({
            id,
            name,
            campaignId,
            dailyBudget: amount,
          })
        )
        state.adGroups = adGroups
        const limitedAmounts = campaigns
          .filter(
            ({ dailyBudgetYn, dailyBudgetAmount }) =>
              dailyBudgetYn === 'Y' &&
              dailyBudgetAmount !== null &&
              dailyBudgetAmount !== undefined &&
              dailyBudgetAmount !== ''
          )
          .map(({ dailyBudgetAmount }) => Number(dailyBudgetAmount))
        state.campaignDailyBudgetLimit =
          limitedAmounts.length > 0 ? Math.min(...limitedAmounts) : null
        const hasSameValue =
          adGroups.length > 1 &&
          adGroups.every(
            (value, index, array) => value.dailyBudget === array[0].dailyBudget
          )
        if (adGroups.length === 1 || hasSameValue) {
          const [first] = adGroups
          const { dailyBudget } = first
          state.dailyBudgetAmount = dailyBudget
        }
        state.isLoading = false
      }
    )

    builder.addCase(updateAdGroupsDailyBudget.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateAdGroupsDailyBudget.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateAdGroupsDailyBudget.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const { hideAdGroupDailyBudgetEdit, showPreview, hidePreview } =
  adGroupDailyBudgetEditSlice.actions
export default adGroupDailyBudgetEditSlice.reducer
